const REQUIRED_ENV = [
  'VITE_CUSTOM_SERVER_URL',
  'VITE_ENVIRONMENT',
  'VITE_FRONT_URL',
  'VITE_FRONT_VERSION',
];

const unsetEnvs = REQUIRED_ENV.reduce((unsetEnvAcc, envString) => {
  if (!import.meta.env[envString]) {
    return [...unsetEnvAcc, envString];
  }
  return unsetEnvAcc;
}, [] as string[]);

if (unsetEnvs.length > 0) {
  throw new Error(`Unset env: ${unsetEnvs}`);
}

const config = {
  env: import.meta.env.VITE_ENVIRONMENT,
  version: import.meta.env.VITE_FRONT_VERSION,
  baseUrl: import.meta.env.VITE_CUSTOM_SERVER_URL,
} as const;

export default config;
